import * as React from "react";

interface GridImageProps {
  src: string;
  style: { [s: string]: string | number };
}

export const GridImage = ({ src, style, children }: React.PropsWithChildren<GridImageProps>) => (
  <div className="grid-image" style={{ backgroundImage: `url('${src}')`, ...(style || {}) }}>
    {children}
  </div>
);

export const GridItemRef = ({ forwardedRef, children }: React.PropsWithRef<React.PropsWithChildren<any>>) => (
  <div className="item-wrapper" ref={forwardedRef}>
    {children}
  </div>
);

export const GridItem = ({ children }) => <div className="item-wrapper">{children}</div>;
